
export class Collection<T> extends Array<T> {

    public getFirstItem(): T {
        if (!this.length) {
            throw new Error('not found first tab')
        }

        return this[0];
    }

    public count(): number {
        return this.length;
    }

    public addItem(item: T): void {
        this.push(item);
    }

    public addFirst(item: T): void {
        this.unshift(item);
    }

    public existItem(item: T): boolean {
        return this.indexOf(item) !== -1;
    }

    public removeItem(item: T): void {
        const index = this.indexOf(item);
        if (index !== -1) {
            this.splice(this.indexOf(item), 1);
        }
    }

    public update(identityName: string, item: T): void {
        const element = this.find((t: T) => t[identityName] === item[identityName]);
        if (element) {
            Object.assign(element, item);
        }
    }
}

export class ArrayCollection<T> extends Collection<T> {

}
